import { render, staticRenderFns } from "./SingleUpgrade.vue?vue&type=template&id=67b5234e&"
import script from "./SingleUpgrade.vue?vue&type=script&lang=js&"
export * from "./SingleUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./SingleUpgrade.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\websites\\newshop\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67b5234e')) {
      api.createRecord('67b5234e', component.options)
    } else {
      api.reload('67b5234e', component.options)
    }
    module.hot.accept("./SingleUpgrade.vue?vue&type=template&id=67b5234e&", function () {
      api.rerender('67b5234e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/SingleUpgrade.vue"
export default component.exports